import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;
`;

const ChipWrapper = styled.div`
  min-height: 22px;
  font-size: 14px;
  line-height: 17px;
  display: inline-flex;
  padding-left: 8px;
  padding-right: 8px;
  font-weight: 400;
  text-align: left;
  background: transparent;
  outline: none;
  border-radius: 16px;
  align-items: center;
  transition: all 0.2s ease 0s;
  ${props => {
    if (props.disabled) {
      return `
        cursor: default;
        background-color: inherit;
        color: rgb(203, 203, 203);
        border: 1px solid rgb(203, 203, 203);
       `;

    } else if (props.selected) {
      return `
        cursor: pointer;
        color: white;


        background-color: #008a16;
        background-color: var(--se-primary, #008a16);
        border: 1px solid #008a16;
        border: 1px solid var(--se-primary, #008a16);
        color: white;
        color: var(--se-primary-contrast, white);
      `;

    } else {
      return `
        cursor: pointer;
        border: 1px solid rgb(67, 67, 67);
        color: rgb(51, 51, 51);
        :hover {
          background-color: #EDEDED;
        }
       `;
    }
  }}
`;

const Label = styled.span`
  white-space: nowrap;
`;

class Chip extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    title: PropTypes.string,
    value: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func
  }

  renderToggle = () => {
    return (<ChipWrapper id ={'chips-'+this.props.value} disabled={this.props.disabled} selected={this.props.selected}>
      <Label>{this.props.title}</Label>
    </ChipWrapper>);
  }

  render = () => {
    return (
      <Container onClick={(event) => {
        if (!this.props.disabled) {
          this.props.onClick(event);
        }
      }} title={this.props.title}>
        {this.renderToggle()}
      </Container>
    );
  }
}

export default Chip;
